import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgTilesLarge(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4 2.75C3.30964 2.75 2.75 3.30964 2.75 4L2.75 13.6C2.75 14.2904 3.30964 14.85 4 14.85L13.6 14.85C14.2904 14.85 14.85 14.2904 14.85 13.6L14.85 4C14.85 3.30964 14.2904 2.75 13.6 2.75L4 2.75ZM5.25 12.35L5.25 5.25L12.35 5.25L12.35 12.35L5.25 12.35Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4 17.15C3.30964 17.15 2.75 17.7096 2.75 18.4L2.75 28C2.75 28.6903 3.30964 29.25 4 29.25H13.6C14.2904 29.25 14.85 28.6903 14.85 28L14.85 18.4C14.85 17.7096 14.2904 17.15 13.6 17.15H4ZM5.25 26.75L5.25 19.65H12.35V26.75H5.25Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M17.1497 4C17.1497 3.30964 17.7093 2.75 18.3997 2.75L27.9997 2.75C28.69 2.75 29.2497 3.30964 29.2497 4V13.6C29.2497 14.2904 28.69 14.85 27.9997 14.85L18.3997 14.85C17.7093 14.85 17.1497 14.2904 17.1497 13.6V4ZM19.6497 5.25V12.35H26.7497V5.25H23.1997L19.6497 5.25Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M18.3997 17.15C17.7093 17.15 17.1497 17.7096 17.1497 18.4L17.1497 28C17.1497 28.6903 17.7093 29.25 18.3997 29.25H27.9997C28.69 29.25 29.2497 28.6903 29.2497 28V18.4C29.2497 17.7096 28.69 17.15 27.9997 17.15L18.3997 17.15ZM19.6497 26.75V19.65H26.7497V26.75H19.6497Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgTilesLarge);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
